import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleAxiosError } from "../../config/action-config";
import {
  reportsTable,
  reportsTable as tableDef,
} from "../../config/grid-columns-defs";
import ControlledTable from "../../component/ControlledTable";
import { getExcelViewer, getReports } from "../../api/reports";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/core";
import download from "downloadjs";
import { showAlert } from "../../actions/alert";
import { TicketFormatter } from "../../config/grid-value-formatters";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function Reports() {
  const classes = useStyles();
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [status, setStatus] = useState("");
  const [severity, setSeverity] = useState("");
  const [ticket, setSTicket] = useState("");
  const [ticketId, setTicketId] = useState("");
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    .toISOString()
    .substring(0, 10);
  let currentDate = date.toISOString().substring(0, 10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  let obj = reportsTable.find((o) => o.headerName === "Ticket");
  if (user.role === "Customer" || user.role === "Subcustomer") {
  } else {
    if (obj === undefined) {
      reportsTable.push({
        headerName: "Ticket",
        field: "flag",
        resizable: true,
        cellStyle: { fontSize: "11px" },
        minWidth: 70,
        // maxWidth: 100,
        valueFormatter: TicketFormatter,
      });
    }
  }
  useEffect(() => {
    refreshTable();
  }, [status, severity, ticket, endDate, ticketId]);

  const checkRole = (role) => {
    switch (role) {
      case "Customer":
        {
          setSTicket("E");
        }
        break;
      case "Subcustomer":
        {
          setSTicket("E");
        }
        break;

      default:
        break;
    }
  };
  const refreshTable = async () => {
    checkRole(user.role);
    try {
      const { data } = await getReports(
        {
          email: user.email,
          status: status,
          datefrom: startDate === null ? "" : startDate,
          dateto: endDate === null ? "" : endDate,
          ticketid: ticketId,
          flag: ticket,
          severity: severity,
          limit: 10,
          offset: 0,
        },
        user.token
      );

      setTotalCount(
        parseInt(data.data.total) === 0 ? -1 : parseInt(data.data.total)
      );
      setRows(data.data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };

  const getRows = async (numRows, startRow) => {
    checkRole(user.role);
    return getReports(
      {
        email: user.email,
        status: status,
        datefrom: "",
        dateto: "",
        ticketid: ticketId,
        flag: ticket,
        severity: severity,
        limit: numRows,
        offset: startRow,
      },
      user.token
    )
      .then((res) => {
        setTotalCount(
          parseInt(res.data.data.total) === 0 ? -1 : res.data.data.total
        );
        return res.data.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const getExcelViewerData = () => {
    if (
      status === "" &&
      ticket === "" &&
      severity === "" &&
      startDate === "" &&
      startDate === "" &&
      ticketId === ""
    ) {
      return dispatch(showAlert("Select any input"));
    }
    return getExcelViewer(
      {
        email: user.email,
        status: status,
        flag: ticket,
        severity: severity,
        datefrom: startDate,
        dateto: endDate,
        ticketid: ticketId,
      },
      user.token
    )
      .then((res) => {
        if (res) {
          download(res.data, new Date().toLocaleDateString() + "-data.csv");
        } else {
          alert("Data not found");
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const resetFilterFields = () => {
    setStatus("");
    setSeverity("");
    setTicketId("");
    setEndDate(null);
    setStartDate(null);
    setSTicket("");
  };
  return (
    <Box className="pmt-container-box">
    
      <Box
        sx={{
          // display: "grid",
          justifyContent: "space-between",
          boxShadow: "0 4px 6px -1px #d0d0d0",
          borderRadius: "8px 8px 0px 0px",
          padding: { sm: "15px 20px", xs: "8px 8px" },
          background: "#fff",
          color: "#101728",
          width: "100%",
        }}
      >
          <Box sx={{ mb: 2 }}>
        <Typography variant="h1" className="pmt-headings-h1">
          Reports
        </Typography>
      </Box>
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          style={  {  display: "flex",
            justifyContent: "space-between",}}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Status
              </InputLabel>
              <Select
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status}
                label="Status"
                size="small"
                sx={{ background: "#fff" }}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
              >
                <MenuItem value={"closed"} className="select-list-font">
                  Closed
                </MenuItem>
                <MenuItem value={"open"} className="select-list-font">
                  Open
                </MenuItem>

                <MenuItem
                  value={"work in progress"}
                  className="select-list-font"
                >
                  Work in progress
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Severity
              </InputLabel>
              <Select
                sx={{ background: "#fff" }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size="small"
                value={severity}
                label="Severity"
                onChange={(e) => {
                  setSeverity(e.target.value);
                }}
              >
                <MenuItem value={"high"} className="select-list-font">
                  High
                </MenuItem>
                <MenuItem value={"low"} className="select-list-font">
                  Low
                </MenuItem>

                <MenuItem value={"medium"} className="select-list-font">
                  Medium
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {user.role === "Customer" || user.role === "Subcustomer" ? (
            <div></div>
          ) : (
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label" size="small">
                  Ticket
                </InputLabel>
                <Select
                  sx={{ background: "#fff" }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={
                    user.role === "Customer" || user.role === "Subcustomer"
                      ? "E"
                      : ticket
                  }
                  label="Ticket"
                  size="small"
                  disabled={
                    user.role === "Customer" || user.role === "Subcustomer"
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    setSTicket(e.target.value);
                  }}
                >
                  <MenuItem className="select-list-font" value={"I"}>
                    Internal
                  </MenuItem>
                  <MenuItem className="select-list-font" value={"E"}>
                    External
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid item lg={2} md={2} sm={4} xs={6}>
            <TextField
              name="TicketId"
              size="small"
              fullWidth
              value={ticketId}
              onChange={(e) => {
                setTicketId(e.target.value);
              }}
              label="Ticket Id"
              type="text"
              // variant="outlined"
            />
          </Grid>

          <Grid item lg={2} md={2} sm={4} xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Date From"
                value={startDate}
                onChange={(newValue) => {
                  setStartDate(FormattedDate(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    sx={{ background: "#fff", borderRadius: "4px" }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Date To"
                shouldDisableDate={disablePrevDates(startDate)}
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(FormattedDate(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    sx={{ background: "#fff", borderRadius: "4px" }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item lg={1} md={1} sm={4} xs={6}>
            <Button
              className="export-button"
              style={{ padding: "5px" }}
              onClick={() => {
                resetFilterFields();
              }}
            >
              Reset
            </Button>
          </Grid>
          <Grid item lg={1} md={1} sm={4} xs={6}>
            <Button
              disabled={/^Trial_User$/i.test(user.role) ? true : false}
              className="export-button"
              style={{ padding: "5px" }}
              onClick={() => {
                getExcelViewerData();
              }}
            >
              Export to Excel
            </Button>
          </Grid>
        </Grid>
      </Box>
      {/* <br /> */}
      <div className="pmt-controll-table">
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          // getRowNodeId={(data) => data?.name || data?.index}
          hasActionButtons={false}
          // tooltipShowDelay="tooltipShowDelay"
        />
      </div>
    </Box>
  );
}
function FormattedDate(newValue) {
  var newDate = newValue.toLocaleDateString();
  var dateArray = newDate.split("/");
  return (
    dateArray[2] +
    "-" +
    dateArray[0].padStart(2, "0") +
    "-" +
    dateArray[1].padStart(2, "0")
  );
}

function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
